import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class RasaWidgetService {
    private scriptLoaded = false;

    constructor() { }

    loadRasaWidget(customData: any): void {
        if (this.scriptLoaded) {
            console.warn('Rasa Webchat script is already loaded.');
            return;
        }
          // Determine the environment and set the script URL
    let scriptUrl: string | null = null;
    if (customData.environment === 'dev') {
        scriptUrl = '//sco-inapp-ai-dev.cisco.com/js/rasa-webchat.js';
    } else if (customData.environment === 'stage'|| customData.environment === 'stg'|| customData.environment === 'stage2'|| customData.environment === 'stg2') {
        scriptUrl = '//sco-inapp-ai-stage.cisco.com/js/rasa-webchat.js';
    } 
    else if (customData.environment === 'prod') {
        scriptUrl = '//sco-inapp-ai.cisco.com/js/rasa-webchat.js';
    }
    // console.log('Script URL:', scriptUrl);

        this.loadScript(scriptUrl, true, () => {
            this.initializeWidget(customData);
        });

        this.scriptLoaded = true;
    }

    private loadScript(src: string, async: boolean, onLoadCallback?: () => void): void {
        const script = document.createElement('script');
        script.src = src;
        script.async = async;

        if (onLoadCallback) {
            script.onload = onLoadCallback;
        }

        document.head.appendChild(script);
    }

    private initializeWidget(customData: any): void {
         const envSet= customData.environment;
        const { environment, ...filteredCustomData } = customData;
        let socketUrl: string | null = null;
        if (envSet === 'dev') {
            socketUrl = '//sco-inapp-ai-dev.cisco.com';
        } else if (envSet === 'stage'|| envSet === 'stg'|| envSet === 'stage2'|| envSet === 'stg2') {
            socketUrl = '//sco-inapp-ai-stage.cisco.com';
        } else if (envSet === 'prod') {
            socketUrl = '//sco-inapp-ai.cisco.com';
        }
        // console.log('Socket URL:', socketUrl);
        // console.log('final payload', filteredCustomData);
        window['customChatData'] =filteredCustomData;
        // console.log('Initializing Rasa Webchat with custom data:', window['customChatData']);
           window['WebChat'].default(
        {
            initPayload: false,
            customData: filteredCustomData,
            socketUrl: socketUrl,
            title: 'SCO AI Assistant',
            showFullScreenButton: true,
            onSocketEvent: {
                'connect': () => {
                    window['setUpInAppBot']();
                    // console.log('connection established!! Welcome!!');
                },
                'disconnect': () => {
                    // console.log('connection lost, attempting to reconnect...');
                    const socket = window['WebChat'].socket;
                    if (socket) {
                        socket.connect();
                    }
                }
            }
        },
        null,
    );

    }

    // private setupMessageObserver(): void {
    //     // Add your custom message observer logic here if needed
    //     // console.log('Message observer setup is complete.');
    // }
}
